import { render } from "./HomeButton.vue?vue&type=template&id=6ce5416a&ts=true"
import script from "./HomeButton.vue?vue&type=script&lang=ts"
export * from "./HomeButton.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__